<template>
  <div id="container">
    <div class="inner">
      <div class="top">
        <h3>{{time}}</h3>
        <p>{{today}}</p>
      </div>
      <div
        class="mask"
        v-if="warn!=''"
      >
        <div class="mask-content">
          <div class="icon"></div>
          <p>{{warn}}</p>
        </div>
      </div>
      <h3 class="titles">填写预约信息</h3>
      <div class="content">
        <div class="top-center">
          <p>
            参观日期：
            <span class="day">{{day}}</span>
          </p>
          <!-- <div class="top-list">
          <div class="items" v-for="(item,index) in teams" :key="index"></div>
          </div>-->
        </div>
        <div class="top-center">
          <div class="p">
            门票类型：
            <div
              class="type"
              v-for="(item ,index) in ticketList"
              :class="{'active':cur==index}"
              :key="index"
              @click="cur=index"
            >{{item.pt_name}}
            </div>
          </div>
        </div>
        <div class="top-center">
          <h3>选择参观门票:</h3>
          <div
            class="list"
            v-for="(item,index) in types"
            :key="index"
            v-show="types"
          >
            <div
              class="title"
              :class="{'active':curs==index,'disable':item.tp_last_stock<=0}"
              @click="selectCur(index,item)"
            >
              {{item.ticket_name}}
              <span>
                ￥
                <span class="num">{{Number(item.ticket_price).toFixed(2)}}</span>
              </span>
            </div>
            <div
              class="des"
              v-if="item.intro"
            >{{item.intro}}
            </div>
            <div
              class="options"
              v-for="(it,ind) in item.tickets_option"
              v-show="item.tickets_option"
              :key="ind"
            >
              <div class="title">
                <span
                  class="iconfont"
                  :class="{'iconduihao':curss==ind&&curs==index}"
                  @click="toggle(index,ind)"
                ></span>
                {{it.ticket_name}}
                <span>
                  ￥
                  <span class="num">{{Number(it.discount_price).toFixed(2)}}</span>
                </span>
                <div class="price">￥{{Number(it.ticket_price).toFixed(2)}}</div>
              </div>
              <div class="des">限一名成人和一名儿童</div>
            </div>
          </div>
        </div>
        <div class="list">
          <h3>身份信息</h3>
          <div class="list-wrapper">
            <div class="item">
              <div class="from-control">
                <span
                  class="name"
                  v-if="curss!=0"
                >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
                <span
                  class="name"
                  v-if="curss==0"
                >家长姓名</span>
                <input
                  type="text"
                  v-model="form.username"
                  placeholder="请填写姓名"
                  @click="showKeyBorder"
                  @blur="closeKeyBorder"
                />
              </div>
            </div>
            <div class="item">
              <div class="from-control">
                <span class="name">证件类型</span>
                <select
                  name="cardType"
                  v-model="form.cardType"
                  :disabled="cur==3"
                >
                  <option
                    v-for="(item, index) in cardType"
                    :key="index"
                    :value="item.cardtype_id"
                  >{{item.card_type}}
                  </option>
                </select>
              </div>
            </div>
            <div class="item">
              <div class="from-control">
                <span class="name">证件号码</span>
                <input
                  type="text"
                  v-model="form.cardNum"
                  placeholder="请填写证件号码"
                  @click="showKeyBorder"
                  @blur="handleToiCardNumBlur"
                  @input="handleToiCardNumChange"
                />
              </div>
            </div>
          </div>
          <div
            class="list-wrapper"
            v-if="curss==0"
          >
            <div class="item">
              <div class="from-control">
                <span class="name">儿童姓名</span>
                <input
                  type="text"
                  v-model="child.username"
                  placeholder="请填写姓名"
                  @click="showKeyBorder"
                  @blur="closeKeyBorder"
                />
              </div>
            </div>
            <div class="item">
              <div class="from-control">
                <span class="name">证件类型</span>
                <select
                  name="cardType"
                  v-model="child.cardType"
                  readyonly
                  disabled
                >
                  <option
                    v-for="(item, index) in cardType"
                    :key="index"
                    :value="item.cardtype_id"
                  >{{item.card_type}}
                  </option>
                </select>
              </div>
            </div>
            <div class="item">
              <div class="from-control">
                <span class="name">证件号码</span>
                <input
                  type="text"
                  v-model="child.cardNum"
                  placeholder="请填写证件号码"
                  @click="showKeyBorder"
                  @blur="closeKeyBorder"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <p v-if="curs>=0&&types.length>0">
          {{types[curs].ticket_name}}
          <span>
            ￥
            <span class="num">{{curss>=0?(Number(types[curs].ticket_price)+Number(ticketList[ticketList.length-1].pt_tickets[0].discount_price)).toFixed(2):Number(types[curs].ticket_price).toFixed(2)}}</span>
          </span>
        </p>
        <p v-if="curss>=0&&types.length>0">
          {{types[curs].tickets_option[curss].ticket_name}}
          <span>
            ￥
            <span class="num">{{Number(types[curs].tickets_option[curss].discount_price).toFixed(2)}}</span>
          </span>
        </p>
        <p
          class="total"
          v-if="curss<0&&types.length>0"
        >
          总计：
          <span>
            ￥
            <span class="num">{{Number(types[curs].discount_price).toFixed(2)}}</span>
          </span>
        </p>
        <p
          class="total"
          v-if="curss>=0&&types.length>0"
        >
          总计：
          <span>
            ￥
            <span class="num">{{(Number(types[curs].ticket_price)+ Number(types[curs].tickets_option[curss].discount_price)+Number(ticketList[ticketList.length-1].pt_tickets[0].ticket_price)).toFixed(2)}}</span>
          </span>
        </p>
      </div>
      <div class="btn-group">
        <div
          class="back-btn"
          @click="goBack"
        >上一步
        </div>
        <div
          class="ok"
          @click="createOrder"
        >下一步
        </div>
      </div>

      <div class="footer">
        <div class="footer-content">
          <p>
            <!-- 设备ID：{{deviceId}} -->
            <span class="tel">
              客服电话
              <span>25650850 25650860</span>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /** @format */

  import { setInterval, clearInterval } from 'timers'
  import U from '../commom'
  import Dwime from '../utils/dw'

  export default {
    name: 'HelloWorld',
    data () {
      return {
        warn: '',
        deviceId: localStorage.deviceNum || '123456789',
        time: '',
        today: '',
        timer: '',
        order: {
          num: ' LY64664666112111',
          date: ' 2019-11-29 10:00-12:00',
        },
        form: {
          username: '',
          cardType: 1,
          cardNum: '',
        },
        child: {
          username: '',
          cardType: 1,
          cardNum: '',
        },
        children_max_age: '',
        children_min_age: '',
        day: '',
        cardType: [],
        teams: [],
        ticketList: 3,
        cur: '',
        types: [],
        curs: -1,
        curss: -1,

        dwime: null,
      }
    },
    watch: {
      cur (val) {
        this.curss = -1
        this.form.cardType = 1
        this.types = this.ticketList[val].pt_tickets
      },
      curs (val) {
        this.curs = val
        this.curss = -1
      },
    },
    mounted () {
      this.getDay()
      this.getLimit()
      this.getTicket()
      this.getScroll()
      if (this.timer == '') {
        this.timer = setInterval(() => {
          this.getDay()
        }, 10000)
      }

      this.dwime = new Dwime()
    },
    destroyed () {
      clearInterval(this.timer)
    },
    methods: {
      getLimit () {
        this.$api.getLimit().then((res) => {
          this.children_min_age = res.data.children_min_age
          this.children_max_age = res.data.children_max_age
        })
      },
      getScroll () {
        var $inner = document.getElementsByClassName('inner')[0]
        var $container = document.getElementById('container')

        var y1 = 0
        var y2 = 0
        var height = 0
        $inner.addEventListener('touchstart', function (event) {
          y1 = event.touches[0].pageY
        })
        $inner.addEventListener('touchmove', function (event) {
          y2 = event.touches[0].pageY
          height = y2 - y1
          var top = document.documentElement.scrollTop || document.body.scrollTop

          if (height > 0) {
            document.documentElement.scrollTop = top - y2 + y1
            document.body.scrollTop = top - y2 + y1
          } else {
            document.documentElement.scrollTop = top + y1 - y2
            document.body.scrollTop = top + (y1 - y2)
          }
        })
      },
      /**
       * TODO 修改键盘的方式
       */
      showKeyBorder (mode) {
        window.scrollTo(0, document.body.clientHeight)
        var str = `0,${window.innerHeight}`
        window.jsObj && jsObj.StartKeyBoardFun()
      },
      closeKeyBorder () {
        window.jsObj && jsObj.CloseKeyBoardFun()
      },
      toggle (index, ind) {
        if (index == this.curs) {
          this.curss = this.curss == 0 ? -1 : 0
        }
      },
      selectCur (index, item) {
        if (item.tp_last_stock > 0) {
          this.curs = index
        }
      },
      /**
       * TODO 修改键盘的逻辑
       */
      goBack () {
        this.closeKeyBorder()
        this.$router.go(-1)
      },
      getDay () {
        var day = new Date()
        var hours = day.getHours()
        var year = day.getFullYear()
        hours = hours < 10 ? '0' + hours : hours
        var min = day.getMinutes()
        min = min < 10 ? '0' + min : min
        var month = day.getMonth() + 1
        var days = day.getDate()
        var week = day.getDay()
        var strWeek = ''
        switch (week) {
          case 0:
            strWeek = '星期日'
            break
          case 1:
            strWeek = '星期一'
            break
          case 2:
            strWeek = '星期二'
            break
          case 3:
            strWeek = '星期三'
            break
          case 4:
            strWeek = '星期四'
            break
          case 5:
            strWeek = '星期五'
            break
          case 6:
            strWeek = '星期六'
            break
        }
        this.time = hours + ':' + min
        this.today = month + '月' + days + '日 ' + strWeek
        this.day = year + '-' + month + '-' + days
      },
      getTicket () {
        this.$api.getTicket(this.day).then((res) => {
          if (res.status == 1) {
            let card_type = []
            for (let i in res.data.cardtype) {
              if (res.data.cardtype[i].cardtype_id == 1) {
                card_type.push(res.data.cardtype[i])
              }
            }
            this.cardType = card_type
            this.ticketList = res.data.pt_data
            if (this.ticketList.length > 0) {
              this.cur = 0
              this.curs = 0
              this.types = this.ticketList[this.cur].pt_tickets
            } else {
              this.warn = '系统维护中'
              setTimeout(() => {
                this.goBack()
              }, 1500)
            }
          }
        })
      },
      /**
       * TODO 键盘调用的调整
       */
      createOrder () {
        // 关闭软键盘
        // onClose();
        this.closeKeyBorder()
        var is_parent = 1
        var td_tp_id = []
        var pt_id = []
        var toi_username = []
        var toi_card_num = []
        var is_children = []
        var is_child = 0
        var toi_cardtype_id = []
        var td_tp_ids = []
        var data = []
        var total = 0
        if (this.form.username == '') {
          this.warn = this.curss < 0 ? '请填写姓名' : '请填写家长姓名'
          setTimeout(() => {
            this.warn = ''
          }, 1500)
          return false
        }

        if (this.form.cardNum == '') {
          this.warn = '请填写证件号码'
          setTimeout(() => {
            this.warn = ''
          }, 1500)
          return false
        }
        // 身份证格式验证
        if (this.form.cardType == 1) {
          if (!U.checkIdcard(this.form.cardNum).status) {
            this.warn = '证件号码不正确'
            setTimeout(() => {
              this.warn = ''
            }, 1500)
            return false
          }
          // 参观票预约，各门票类型增加单独的年龄限制：
          // 学生票：6岁（不含）-24岁（含）
          // 儿童票：6岁（含）以下
          // 老年票：70岁（含）以上
          // 成人票：不做限制
          var age = U.analyzeIDCard(this.form.cardNum)
          if (this.curs != -1) {
            var obj = this.ticketList[this.cur]
            if (obj.pt_name == '老人票' && age >= 70) {
              this.warn =
                '70岁及以上老年人无需预约，可凭身份证登记领取免费参观票。'
              setTimeout(() => {
                this.warn = ''
              }, 1500)
              return false
            }
            if (
              obj.pt_name == '儿童票' &&
              age >= this.ticketList[this.cur - 1].age_limit &&
              age <= this.ticketList[this.cur - 1].age_limit_max
            ) {
              this.warn = '请购买学生票'
              setTimeout(() => {
                this.warn = ''
              }, 1500)
              return false
            }
            if (age < obj.age_limit || age > obj.age_limit_max) {
              this.warn =
                '请添加' +
                obj.age_limit +
                '岁至' +
                obj.age_limit_max +
                '岁的' +
                obj.pt_name.slice(0, obj.pt_name.length - 1)
              setTimeout(() => {
                this.warn = ''
              }, 1500)
              return false
            }
          }
        }
        td_tp_id.push(this.types[this.curs].td_tp_id)
        pt_id.push(this.ticketList[this.cur].pt_id)
        toi_username.push(this.form.username)
        toi_card_num.push(this.form.cardNum)
        is_child = this.curss > -1 ? 1 : 0
        is_children.push(is_child)
        toi_cardtype_id.push(this.form.cardType)
        td_tp_ids.push('')
        var obj = {
          toi_username: this.form.username,
          pt_name: this.ticketList[this.cur].pt_name,
          cardName: this.cardType[this.form.cardType - 1].card_type,
          toi_card_num: this.form.cardNum,
          ticket_name: this.types[this.curs].ticket_name,
          price: this.types[this.curs].ticket_price,
        }

        if (this.curss > -1) {
          obj.ticket_name2 = this.types[this.curs].tickets_option[
            this.curss
            ].ticket_name
          obj.price2 = this.types[this.curs].tickets_option[
            this.curss
            ].discount_price
        }
        data.push(obj)
        if (this.curss > -1) {
          var is_parent = 2
          if (this.child.username == '') {
            this.warn = '请填写儿童姓名'
            setTimeout(() => {
              this.warn = ''
            }, 1500)
            return false
          }
          if (this.child.cardNum == '') {
            this.warn = '请填写证件号码'
            setTimeout(() => {
              this.warn = ''
            }, 1500)
            return false
          }
          if (this.child.cardType == 1) {
            if (!U.checkIdcard(this.child.cardNum).status) {
              this.warn = '证件号码不正确'
              setTimeout(() => {
                this.warn = ''
              }, 1500)
              return false
            }
            var age = U.analyzeIDCard(this.child.cardNum)
            var obj = this.ticketList[this.cur]
            if (age < this.children_min_age || age > this.children_max_age) {
              this.warn =
                '儿童乐园票儿童年龄是' +
                this.children_min_age +
                '岁（含）-' +
                this.children_max_age +
                '岁（含），请重新填写'
              setTimeout(() => {
                this.warn = ''
              }, 1500)
              return false
            }
          }
          if (this.curs == 0) {
            var age = U.analyzeIDCard(this.child.cardNum)
            var obj2 = ''
            if (age > this.ticketList[this.ticketList.length - 1].age_limit_max) {
              td_tp_id.push(this.types[this.curs].td_tp_id)
              pt_id.push(this.ticketList[this.ticketList.length - 2].pt_id)
              toi_username.push(this.child.username)
              toi_card_num.push(this.child.cardNum)
              is_children.push(2)
              toi_cardtype_id.push(this.child.cardType)
              td_tp_ids.push(
                this.types[this.curs].tickets_option[this.curss].td_tp_id
              )
              obj2 = {
                toi_username: this.child.username,
                pt_name: '学生票',
                cardName: this.cardType[this.child.cardType - 1].card_type,
                toi_card_num: this.child.cardNum,
                ticket_name: this.ticketList[this.ticketList.length - 2]
                  .pt_tickets[this.curss].ticket_name,
                price: this.ticketList[this.ticketList.length - 2].pt_tickets[
                  this.curss
                  ].ticket_price,
              }
            } else {
              td_tp_id.push(this.types[this.curs].td_tp_id)
              pt_id.push(this.ticketList[this.ticketList.length - 1].pt_id)
              toi_username.push(this.child.username)
              toi_card_num.push(this.child.cardNum)
              is_children.push(2)
              toi_cardtype_id.push(this.child.cardType)
              td_tp_ids.push(
                this.types[this.curs].tickets_option[this.curss].td_tp_id
              )
              obj2 = {
                toi_username: this.child.username,
                pt_name: '儿童票',
                cardName: this.cardType[this.child.cardType - 1].card_type,
                toi_card_num: this.child.cardNum,
                ticket_name: this.ticketList[this.ticketList.length - 2]
                  .pt_tickets[this.curss].ticket_name,
                price: this.ticketList[this.ticketList.length - 2].pt_tickets[
                  this.curss
                  ].ticket_price,
              }
            }
            data.push(obj2)
          }
        }
        if (this.curss >= 0) {
          if (age > this.ticketList[this.ticketList.length - 1].age_limit_max) {
            total = (
              Number(this.types[this.curs].ticket_price) +
              Number(
                this.types[this.curs].tickets_option[this.curss].discount_price
              ) +
              Number(
                this.ticketList[this.ticketList.length - 2].pt_tickets[0]
                  .ticket_price
              )
            ).toFixed(2)
          } else {
            total = (
              Number(this.types[this.curs].ticket_price) +
              Number(
                this.types[this.curs].tickets_option[this.curss].discount_price
              ) +
              Number(
                this.ticketList[this.ticketList.length - 1].pt_tickets[0]
                  .ticket_price
              )
            ).toFixed(2)
          }
        } else {
          total = Number(this.types[this.curs].ticket_price).toFixed(2)
        }
        this.post = {
          td_tp_id,
          pt_id,
          toi_username,
          toi_card_num,
          toi_cardtype_id,
          is_children,
          is_parent,
          td_tp_ids,
        }

        localStorage.post = JSON.stringify(this.post)
        var confirmData = {
          day: this.day,
          list: data,
          total: total,
        }
        localStorage.confirmData = JSON.stringify(confirmData)

        this.$router.push({
          path: '/ticket_confirm',
        })
      },
      handleToiCardNumBlur (event) {
        this.closeKeyBorder()
        const card_type = this.form.cardType
        if (card_type == 1) {
          const card_num = event.target.value
          const uInfo = this.analyzeIDCard(card_num)
          console.log(uInfo)
          const pt_data = this.ticketList
          if (uInfo != '')
            for (let i in pt_data) {
              if (uInfo >= pt_data[i].age_limit && uInfo <= pt_data[i].age_limit_max) {
                this.cur = i
                this.types = pt_data[i].pt_tickets
                break
              }
            }
        }
      },
      handleToiCardNumChange (event) {
        console.log(event)
        const card_type = this.form.cardType
        if (card_type == 1) {
          const card_num = event.target.value
          if (card_num.length == 18) {
            this.closeKeyBorder()
            const uInfo = this.analyzeIDCard(card_num)
            console.log(uInfo)
            const pt_data = this.ticketList
            if (uInfo != '')
              for (let i in pt_data) {
                if (uInfo >= pt_data[i].age_limit && uInfo <= pt_data[i].age_limit_max) {
                  this.cur = i
                  this.types = pt_data[i].pt_tickets
                  break
                }
              }
          }

        }
      },
      /**
       * 根据身份证号得到姓别和精确计算年龄
       */
      analyzeIDCard (IDCard) {
        var Age = ''
        //获取用户身份证号码
        var userCard = IDCard
        //如果身份证号码为undefind则返回空
        if (!userCard) {
          return sexAndAge
        }
        //获取出生年月日
        //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
        var yearBirth = userCard.substring(6, 10)
        var monthBirth = userCard.substring(10, 12)
        var dayBirth = userCard.substring(12, 14)
        //获取当前年月日并计算年龄
        var myDate = new Date()
        var monthNow = myDate.getMonth() + 1
        var dayNow = myDate.getDay()
        var age = myDate.getFullYear() - yearBirth
        if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
          age--
        }
        //得到年龄
        Age = age
        //返回性别和年龄
        return Age
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /** @format */

  .container {
    width: 100%;
    min-height: 1920px;
    background: #f0f0f0;
    overflow-y: scroll;
    position: relative;
    padding-bottom: 165px;

    .inner {
      height: auto;
    }

    .top {
      padding: 30px 32px;
      color: #4d4d4d;
      font-size: 25px;

      h3 {
        font-size: 70px;
        margin: 0;
      }
    }

    .titles {
      font-size: 60px;
      letter-spacing: 3px;
      color: #0c5193;
      text-align: left;
      width: 100%;
      padding: 90px 50px 30px;
    }
  }

  .btn-group {
    margin: 40px auto 0;
    width: 960px;

    .back-btn {
      display: inline-block;
      width: 330px;
      height: 98px;
      border: 1px solid #b95020;
      color: #b95020;
      border-radius: 49px;
      font-size: 30px;
      line-height: 96px;
      text-align: center;
      cursor: pointer;
      margin-right: 57px;
      margin-left: 40px;
    }

    .ok {
      width: 488px;
      height: 98px;
      line-height: 98px;
      background: #b95020;
      color: #fff;
      font-size: 30px;
      border-radius: 49px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
    }
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    z-index: 999;
    transition: all ease-in-out 300ms;

    .mask-content {
      width: 600px;
      height: 384px;
      background: #fff;
      border-radius: 6px;
      padding: 65px;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .icon {
        width: 102px;
        height: 102px;
        background: url(.././assets/icon.png) no-repeat;
        background-size: cover;
        margin: 0 auto 80px;
      }

      p {
        color: #5c5c5c;
        font-size: 30px;
        text-align: center;
      }
    }
  }

  .content {
    width: 1002px;
    margin: 0 auto;
    min-height: 764px;
    position: relative;

    .top-center {
      font-size: 34px;
      margin-bottom: 24px;
      padding: 40px;
      line-height: 50px;
      background: #fff;
      border-radius: 4px;

      .p {
        font-size: 40px;
        color: #474747;
        font-weight: 600;
        margin-top: -20px;

        .type {
          width: 160px;
          height: 50px;
          color: #474747;
          padding-left: 35px;
          position: relative;
          display: inline-block;
          margin-right: 64px;
          margin-top: 20px;
          cursor: pointer;

          &:after {
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            border: 3px solid #ce6b3d;
            left: 3px;
            border-radius: 50%;
            z-index: 1;
          }

          &.active:before {
            content: '';
            width: 15px;
            height: 15px;
            background: #ce6b3d;
            position: absolute;
            top: 50%;
            left: 8.25px;
            transform: translateY(-50%);
            z-index: 2;
            border-radius: 7.5px;
          }
        }
      }

      p {
        font-size: 40px;
        color: #474747;
        font-weight: 600;

        span {
          color: #005192;
        }
      }

      .top-list {
        overflow: hidden;

        .item-list {
          width: 280px;
          height: 80px;
          text-align: center;
        }
      }

      h3 {
        font-size: 40px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding-bottom: 30px;
      }

      .list {
        padding: 30px 0;
        border-bottom: 2px solid rgba(0, 0, 0, 0.2);

        &:last-child {
          border-bottom: 0 none;
        }

        .title {
          font-size: 40px;
          color: #000;
          font-weight: 600;
          vertical-align: middle;
          margin-bottom: 18px;
          padding-left: 60px;
          position: relative;

          &.disable {
            opacity: 0.45;
            cursor: none;
          }

          .price {
            font-size: 30px;
            position: absolute;
            bottom: -30px;
            right: 0;
            color: #e8593e;
            text-decoration: line-through;
          }

          &:after {
            content: '';
            width: 22px;
            height: 22px;
            position: absolute;
            top: 50%;
            left: 2px;
            transform: translateY(-50%);
            border: 3px solid #ce6b3d;
            border-radius: 50%;
          }

          &.active:before {
            content: '';
            width: 15px;
            height: 15px;
            background: #ce6b3d;
            position: absolute;
            top: 50%;
            left: 8.25px;
            transform: translateY(-50%);
            z-index: 2;
            border-radius: 7.5px;
          }

          span {
            float: right;
            color: #e8593e;
            font-size: 20px;
            line-height: 50px;

            .num {
              font-size: 40px;
            }
          }
        }

        .des {
          font-size: 30px;
          color: #808080;
        }

        .options {
          padding: 30px 0 0px 30px;

          .title {
            padding: 0;

            .iconfont {
              font-size: 34px;
              display: inline-block;
              border: 1px solid #ce6b3d;
              border-radius: 4px;
              width: 36px;
              height: 36px;
              margin-right: 5px;
              text-align: center;
              line-height: 36px;
              color: #ce6b3d;
              float: none;
              vertical-align: middle;
            }
          }

          .title:after,
          .title::before {
            display: none;
          }
        }
      }
    }

    .list {
      background: #fff;
      border-radius: 4px;

      h3 {
        font-size: 40px;
        color: #000;
        padding: 40px 40px 30px;
      }

      .list-wrapper {
        padding: 0 50px;
        position: relative;
        border-top: 1px dashed #005192;

        &:after {
          content: '';
          width: 30px;
          height: 60px;
          border: 1px solid #f0f0f0;
          background: #f0f0f0;
          border-left: 0 none;
          border-radius: 0 30px 30px 0;
          position: absolute;
          top: -34px;
          left: -2px;
          z-index: 3;
        }

        &:before {
          content: '';
          width: 30px;
          height: 60px;
          border: 1px solid #f0f0f0;
          background: #f0f0f0;
          border-right: 0 none;
          border-radius: 30px 0 0 30px;
          position: absolute;
          top: -34px;
          right: -2px;
          z-index: 3;
        }

        .item {
          padding: 40px 0;
          border-bottom: 1px solid #b5b5b5;

          &:last-child {
            border: 0 none;
          }

          .from-control {
            font-size: 40px;
          }

          span {
            display: inline-block;
            width: 164px;
            text-align: justify;
            color: #000;
            font-size: 40px;
            font-weight: 600;
            margin-right: 20px;
          }

          input {
            border: 0 none;
            outline: 0 none;
            font-size: 40px;
            line-height: 40px;
          }

          select {
            /*很关键：将默认的select选择框样式清除*/
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;

            /*在选择框的最右侧中间显示小箭头图片*/
            background: url('.././assets/arrow.png') no-repeat scroll right center transparent;

            /*为下拉小箭头留出一点位置，避免被文字覆盖*/
            padding-right: 14px;
            // background: #fff;
            font-size: 40px;
            outline: 0 none;
            border: 0 none;
            line-height: 50px;
            height: 50px;
            background-size: 5%;
            width: 690px;
          }

          option {
            border: none;
            outline: none;
            /*很关键：将默认的select选择框样式清除*/
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            /*将背景改为红色*/
            background: #fff;
            /*加padding防止文字覆盖*/
            padding-right: 0.14rem;
          }
        }
      }
    }
  }

  .bottom {
    margin: 52px auto;
    width: 850px;

    p {
      font-size: 35px;
      color: #353535;
      margin-bottom: 30px;
      overflow: hidden;

      span {
        float: right;
        display: inline-block;
        font-size: 24px;
        color: #e8593e;
        line-height: 34px;

        .num {
          font-size: 34px;
          font-weight: 600;
        }
      }

      &.total {
        font-size: 40px;
        text-align: right;
        line-height: 40px;

        span {
          line-height: 40px;
        }
      }
    }
  }

  .ok {
    width: 670px;
    height: 98px;
    line-height: 98px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 3px;
    color: #fff;
    background: rgba(185, 80, 32, 1);
    border-radius: 49px;
    margin: 50px auto;
    cursor: pointer;
  }

  .back-btn {
    width: 670px;
    height: 98px;
    background: rgba(0, 81, 146, 0);
    border: 2px solid rgba(185, 80, 32, 1);
    border-radius: 49px;
    line-height: 98px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 3px;
    color: rgba(185, 80, 32, 1);
    margin: 0 auto;
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 24px;
    width: 100%;

    .footer-content {
      padding: 60px;
    }

    p {
      color: #5a5a5a;
      font-size: 20px;
      overflow: hidden;
      vertical-align: middle;

      .tel {
        float: right;
        color: #1c78f7;
        font-size: 20px;
        display: inline-block;
        vertical-align: middle;

        span {
          margin-left: 10px;
          font-size: 34px;
          font-weight: 800;
          vertical-align: middle;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Ticket_buy.vue